import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './auth-provider';
import { useDispatch } from 'react-redux';
import { resetActiveUserState } from '../state/features/users/users-slice';
import { tokenStorageKey } from './auth-constants';

export const LoggedOut: FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // This is a failsafe if we somehow should land on this page after login
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
      return;
    }

    dispatch(resetActiveUserState());
    localStorage.removeItem(tokenStorageKey);
  }, [dispatch, isAuthenticated, navigate]);

  // This page is shown after log out redirect and before login redirect
  // The page is empty to hide that there are two redirects on log out
  return null;
};
